module.exports = __webpack_public_path__ + "img/waitVerify.d0ecf562.png";